function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCameraFormIcon(_ref, svgRef) {
  var _ref2, _ref3, _ref4;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 129,
    height: 129,
    rx: 64.5,
    fill: "#0420E9",
    fillOpacity: 0.05,
    style: (_ref2 = {
      fill: "#0420E9"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.0157 0.1255 0.9137)"), _defineProperty(_ref2, "fillOpacity", 0.05), _ref2)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7613 40.8506H39.4982M63.3071 64.6653V40.8506M44.0285 59.8743L83.8413 70.6552L81.5358 74.3535L76.2423 84.4537L73.9369 88.1506L39.2363 78.8182L44.0285 59.8743Z",
    stroke: "#394DFC",
    style: (_ref3 = {
      stroke: "#394DFC"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.2235 0.3020 0.9882)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 4.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.483 75.25L89.7637 76.6468L86.9347 87.075L79.0137 84.9805",
    stroke: "#394DFC",
    style: (_ref4 = {
      stroke: "#394DFC"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.2235 0.3020 0.9882)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 4.03125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraFormIcon);
export default __webpack_public_path__ + "static/media/camera_form_icon.8dc4850f13747b0006043b6596d60618.svg";
export { ForwardRef as ReactComponent };